import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useDelete = () => {
  const { mutate: deleteScenario, isPending } = useAppMutation([QueryKey.DELETE_SCENARIO], {
    mutationFn: ({ scenarioId }: { scenarioId: string }) =>
      ApiService.delete({
        endpoint: BackendRoute.SCENARIOS,
        routePath: [scenarioId],
      }),
  });
  return { deleteScenario, isPending };
};
